import { Button, spacings, ThemeProvider, Typography } from '@guidde/design-system'
import { Stack } from '@mui/material'

import { useListenForSsoLogin } from 'hooks'

type Props = {
    authUrl: string
}

export const PageSsoLoginRequired = ({ authUrl }: Props) => {
    useListenForSsoLogin()

    return (
        <ThemeProvider>
            <Stack
                spacing={spacings['3xl']}
                sx={{
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: spacings['5xl'],
                    textAlign: 'center',
                }}
            >
                <Stack spacing={spacings.xl}>
                    <Typography
                        variant="heading"
                        size="sm"
                        fontWeight="semibold"
                    >
                        Almost there!
                    </Typography>
                    <Typography
                        variant="text"
                        size="md"
                        color="grey.500"
                    >
                        Log in once with your work email to view the video—you’ll have ongoing access from now on.
                    </Typography>
                </Stack>
                <Button
                    variant="outlined"
                    color="secondary"
                    size="large"
                    onClick={() => {
                        window.open(authUrl, '_blank')
                    }}
                >
                    Sign in with SSO
                </Button>
            </Stack>
        </ThemeProvider>
    )
}
